<template>
    <a-modal
        :class="'modal'"
        :title="$t('globals.navigation.uploads_modal.title')"
        :destroyOnClose="true"
        v-model:open="modal_visible"
        :footer="null"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '1536px' }"
    >
        <div class="form-container">
            <uploads-table />
        </div>
    </a-modal>
</template>

<script>
import UploadsTable from '@/components/tables/Uploads.vue';

export default {
    components: {
        UploadsTable,
    },
    data() {
        return {
            modal_visible: false,
        };
    },
    props: {
        processing: Boolean,
    },

    methods: {
        showModal() {
            this.modal_visible = true;
        },
    },
};
</script>
